function storeData(access_token, displayName, role, token_type) {
  return {
    type: 'ADD_DATA',
    access_token: access_token,
    displayName: displayName,
    role: role,
    token_type: token_type,
  };
}

function removeData() {
  return {
    type: 'REMOVE_DATA',
  };
}

export { storeData, removeData };
